import React from 'react'

import { array, bool, func } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function MenuItemIcon({ icon = null, isFontAwesomeIcon = false, svgComponent: SvgComponent = null }) {
  if (SvgComponent) {
    return <SvgComponent width="24" height="24" />
  }

  if (isFontAwesomeIcon) {
    return (
      <Icon
        type={icon}
        notSpaced
        className="custom-font-icon custom-font-icon--centered custom-icon--light"
      />
    )
  }

  return <i className={`custom-font-icon icon-${icon} custom-icon--light`} />
}

MenuItemIcon.propTypes = {
  icon: array,
  isFontAwesomeIcon: bool,
  svgComponent: func,
}

export default MenuItemIcon
